
import React, { useContext, useState } from 'react'; // Importa React y hooks.
import './language.css';  // importacion de la hoja de estilos para esta pagina
import Header from '../../components/Header/Header'; // Componente de la cabezera de la pagina.
import SimpleTitle from '../../components/SimpleTitle/SimpleTitle'; // Componente para titulos simples
import LanguageSelector from '../../components/LanguageSelector/LanguageSelector';
import useTranslation from '../../hooks/useTranslation';
import { TranslationContext } from '../../helpers/Context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye } from '@fortawesome/free-solid-svg-icons';
 




const Language = () => {
    const T = useTranslation()
    
    const { contextTranslate, language } = useContext(TranslationContext);
    return (
        <div className='body  right-[auto] left-[auto] flex flex-col bg-white  h-[80vh]  max-w-[1024px] items-center justify-center w-[100vw] overflow-hidden'>
            <Header  minimal={true} />
            <div className='overflow-scroll p-4 flex flex-col flex-1 bg-[#eaf7f5] flex w-full items-center gap-5'>
                <SimpleTitle text='Seleccione el idioma' />
                <div className='flex gap-2 items-center'>
                    <span>{T("Idioma")}</span>
                    <LanguageSelector />
                </div>
                <table className='max-w-[95vw] min-w-[95vw] w-[95vw]'>
                    <thead>
                        <tr className='bg-white px-2 text-center'>
                            <th>ID</th>
                            <th>KEY</th>
                            <th>{language}</th>
                            <th>Accion</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            Object.keys(contextTranslate).map((key,index) => {
                                const keygen = key.replaceAll(' ', '')
                                return (
                                    <tr key={'item-'+keygen}>
                                        <th className='w-2/12'>
                                            {index}
                                        </th>
                                        <th className='w-4/12 text-left text-gray-500'>
                                            <span>
                                             {key} 
                                            </span>
                                        </th>
                                        <th className='w-4/12'>
                                            <input 
                                                className='p-1 rounded bg-transparent' 
                                                type="text" 
                                                name="" 
                                                id="" 
                                                disabled
                                                defaultValue={contextTranslate?.[key]?.[language]}
                                                />
                                            
                                        </th>
                                        <th className='w-2/12 flex gap-4'>
                                           <button>
                                                <FontAwesomeIcon icon={faEdit} />
                                           </button>
                                           <button>
                                                <FontAwesomeIcon icon={faEye} />
                                           </button>
                                        </th>
                                          
                                          
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
                

                
            </div>
        </div>
    );
};

export default Language;